"use client"

import {
  PageContainer,
  PageHeader,
  PageHeaderLeading,
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
  getPageHeader,
} from '@yeshuman/sdk'
import { LayoutGrid } from "lucide-react"

export function RecruiterPipelinePage() {
  const { title, description } = getPageHeader(
    "/recruiter/pipeline",
    "Pipeline",
    "Brief-centric stages for your searches. Kanban tooling will connect here once the placement model lands.",
  )

  return (
    <PageContainer>
      <PageHeader leading={<PageHeaderLeading />} title={title} description={description} icon={<LayoutGrid className="h-5 w-5" />} />
      <Card>
        <CardHeader>
          <CardTitle>Coming soon</CardTitle>
          <CardDescription>
            Pipeline stages (sourced, contacted, screening, submitted, client loop, outcome) will be backed by a
            Brief-bound model distinct from employer application stages.
          </CardDescription>
        </CardHeader>
        <CardContent className="text-sm text-muted-foreground">
          Use <strong>Briefs</strong> for the case file and <strong>Talent</strong> for search and CVs until this board
          is wired to live data.
        </CardContent>
      </Card>
    </PageContainer>
  )
}
